import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9cd3e6f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "console_wrap" }
const _hoisted_2 = { class: "live_monitor" }
const _hoisted_3 = { class: "live_monitor_view mod_c" }
const _hoisted_4 = { class: "live_nav" }
const _hoisted_5 = { class: "current" }
const _hoisted_6 = {
  key: 0,
  class: "current_url"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "current_title" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" 开启彩排模式后，观众须验证密码后才能进入直播间。如"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 直播间启用了密码观看，关闭彩排模式后则自动恢复原有"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 观看密码。彩排模式的启用和关闭不影响其他授权设置。 ")
], -1))
const _hoisted_11 = { class: "live_dress" }
const _hoisted_12 = { class: "dress_name" }
const _hoisted_13 = ["data-clipboard-text"]
const _hoisted_14 = { class: "mod_c_tbody" }
const _hoisted_15 = {
  key: 1,
  class: "view_content_box"
}
const _hoisted_16 = {
  key: 0,
  class: "live_monitor_mode mod_c"
}
const _hoisted_17 = { class: "skeleton" }
const _hoisted_18 = { class: "skeleton_tabs" }
const _hoisted_19 = { class: "skeleton_block" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ske_con_title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "avatar" }),
  /*#__PURE__*/_createElementVNode("div", { class: "avatar_title" })
], -1))
const _hoisted_21 = { class: "ske_con_cen" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ske_con_cen_item" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ske_con_foot" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "botton" }, null, -1))
const _hoisted_25 = {
  key: 1,
  class: "live_monitor_mode mod_c"
}
const _hoisted_26 = { class: "mod_c_title mode_tabs" }
const _hoisted_27 = ["data-key", "data-index"]
const _hoisted_28 = {
  key: 0,
  class: "mode_tabs_tag"
}
const _hoisted_29 = {
  class: "icon",
  style: {"width":"2.5em","height":"1em","vertical-align":"middle","fill":"currentColor","overflow":"hidden"},
  viewBox: "0 0 2560 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "1046"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M640 0h1920v384c0 353.450667-286.549333 640-640 640H0v-384C0 286.549333 286.549333 0 640 0z",
  fill: "#f78533",
  "p-id": "1047"
}, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M987.008 560.597333c11.648-16.682667 21.973333-29.696 30.976-38.997333-87.978667-51.029333-148.138667-120.021333-180.48-207.018667l-36.992 14.506667c32.341333 91.008 94.506667 168.149333 186.453333 231.509333z m-436.992 7.466667c70.997333-59.648 128.981333-136.32 173.994667-229.973333l-39.509334-16.512c-36.693333 82.346667-92.16 153.856-166.485333 214.485333 12.629333 10.368 23.296 21.034667 32 32z m377.002667 225.024l37.973333-25.002667a2582.954667 2582.954667 0 0 0-121.472-169.984l-32.512 20.48c22.826667 32 43.733333 62.421333 62.72 91.264-86.997333 3.968-164.906667 7.082667-233.728 9.258667 47.018667-61.696 91.178667-128 132.48-199.04l-42.965333-19.498667c-45.653333 88.021333-88.021333 154.538667-127.018667 199.509334-12.672 12.373333-26.496 21.504-41.514667 27.52l22.016 42.496a365.44 365.44 0 0 1 45.994667-8.533334 8946.773333 8946.773333 0 0 1 268.245333-16.213333c10.496 16.469333 20.437333 32.426667 29.781334 47.744z m523.946666-7.509333c37.034667 0 55.552-19.2 55.552-57.514667V302.592h-36.522666v416c0 18.986667-9.514667 28.501333-28.501334 28.501333-14.976 0-33.152-1.194667-54.485333-3.498666 3.328 14.976 5.674667 28.672 6.997333 40.96 22.016 0.682667 40.96 1.024 57.002667 1.024z m-329.984-374.485334c9.002667-9.344 19.029333-19.328 30.037334-29.994666a1603.712 1603.712 0 0 0-76.032-69.034667l-26.026667 25.002667a1279.317333 1279.317333 0 0 1 72.021333 74.026666z m75.52 235.008V365.098667h116.48v281.002666h36.010667V330.069333H1160.533333v316.032h36.010667z m230.485334 28.501334V343.04h-34.986667v331.52h34.986667z m-290.474667 121.472c53.674667-31.317333 90.837333-67.498667 111.488-108.501334a2016.512 2016.512 0 0 1 98.986667 87.04l27.008-30.549333a3751.594667 3751.594667 0 0 0-112.981334-89.984c9.301333-30.677333 13.994667-71.338667 13.994667-122.026667V408.106667h-36.522667v125.013333c0 59.989333-8.149333 105.173333-24.490666 135.509333-18.346667 34.986667-52.309333 66.816-101.973334 95.488 8.96 10.666667 17.152 21.333333 24.490667 32z m-33.493333-256.512c10.666667-11.946667 20.309333-22.485333 29.013333-31.488a2147.925333 2147.925333 0 0 0-79.530667-67.498667l-24.490666 27.52c19.968 18.005333 44.970667 41.813333 75.008 71.466667z m-18.005334 248.533333c9.984-39.68 26.154667-101.162667 48.469334-184.533333a411.306667 411.306667 0 0 1-39.466667-18.474667c-13.653333 66.986667-30.336 128.341333-50.005333 183.978667l40.96 19.029333z m728.490667 6.485333v-186.026666h153.514667v27.008h40.96V407.594667h-194.474667V298.581333h-43.008v109.013334h-192.512v227.968h41.002667v-26.965334h151.509333v185.984h43.008z m153.514667-223.018666h-153.514667V444.586667h153.514667v126.976z m-196.522667 0h-151.466667V444.586667h151.466667v126.976z",
  fill: "#FFFFFF",
  "p-id": "1048"
}, null, -1))
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { class: "mode_view" }
const _hoisted_34 = {
  key: 0,
  class: "live_chat mod_c"
}
const _hoisted_35 = { class: "nochat" }
const _hoisted_36 = { class: "nochat_tabs" }
const _hoisted_37 = { class: "nochat_cen" }
const _hoisted_38 = { class: "content" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, null, -1))
const _hoisted_40 = { class: "right" }
const _hoisted_41 = { class: "con_ske" }
const _hoisted_42 = { class: "nochat_foot" }
const _hoisted_43 = { class: "footer" }
const _hoisted_44 = { class: "img_left" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img_right" }, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "foot_box" }, [
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_47 = {
  key: 1,
  class: "live_chat mod_c"
}
const _hoisted_48 = ["data-key"]
const _hoisted_49 = { class: "chat_msg_wrap" }

import { computed, defineAsyncComponent, ref, createVNode, onUnmounted, reactive, onMounted } from 'vue';
import { onBeforeRouteLeave, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { message, Switch, Modal, Popover, Skeleton } from 'ant-design-vue';
import { useConsoleStore } from '@/pinia/console';
import ClipboardJS from 'clipboard';
import LiveChat from './liveChat/LiveChat.vue';
import MemberList from './liveSelect/MemberList.vue';
import ForbiddenWord from './liveSelect/ForbiddenWord.vue';
import BlackList from './liveSelect/BlackList.vue';
import { useThrottleFn } from '@vueuse/core';

import http from '@/api';
import { ExclamationCircleFilled } from '@ant-design/icons-vue';
import { useHomeStore } from '@/pinia/home';
import {
  Authority,
  ConsoleClass,
  GroupChat,
  MemberClass,
  MemberUpdata,
  MsgComment,
  PrivateChatView,
  SocketGMsg,
  SocketPMsg,
  subClass,
} from '@/pinia/types/console';
import EventBus from '@/components/EventBus';
import { getHelperStatus, getUserCache } from '@/plugins/cookie';
import { clearPending } from '@/plugins/http';
import { LightGMsg, LightSocketGMsg } from '@/pinia/types/livechat';
import { useSocketStore } from '@/pinia/socket';
import { socketClearMsg, socketDelMsg, socketSetMsgShow, socketSetMsgTop } from './liveChat/socketAction';


export default /*#__PURE__*/_defineComponent({
  __name: 'Console',
  setup(__props) {

const LiveView = defineAsyncComponent(() => import('./LiveView.vue'));
const aSwitch = Switch;
const aPopover = Popover;
const aSkeleton = Skeleton;

const WebLive = defineAsyncComponent(() => import('./liveMode/WebLive.vue'));
const PushLive = defineAsyncComponent(() => import('./liveMode/PushLive.vue')); // 推流
const PullLive = defineAsyncComponent(() => import('./liveMode/PullLive.vue')); // 拉流
const FileLive = defineAsyncComponent(() => import('./liveMode/FileLive.vue')); // 文档
const InteractLive = defineAsyncComponent(() => import('./liveMode/InteractLive.vue')); // 互动直播
const Multilingual = defineAsyncComponent(() => import('./liveMode/Multilingual.vue')); // 多语
const PlatformPushs = defineAsyncComponent(() => import('./liveMode/PlatformPushs.vue'));
const Virtual = defineAsyncComponent(() => import('./liveMode/Virtual.vue')); // 虚拟直播
const recordBroad = defineAsyncComponent(() => import('./liveMode/recordBroad.vue')); // 列表录播

const helperStatus = getHelperStatus();
const store = useStore();
const toViewLoading = ref(true); // 视图的loading

onBeforeRouteLeave(() => {
  store.commit('home/customLayoutStyle', false);
});
const msgTimer = ref<any>();
const tabKey = ref(0);
const chatList = [
  { key: 0, title: '聊天互动' },
  { key: 1, title: '在线观众' },
  { key: 2, title: '禁言列表' },
  { key: 3, title: '黑名单' },
];
const onSwitchTab = (event: Event) => {
  if ((event.target as HTMLInputElement).dataset.key)
    tabKey.value = parseInt((event.target as HTMLInputElement).dataset.key as string, 10);
};
const showView = (key: number) => {
  return key === tabKey.value;
};
// 直播模式
const judgeMode = useConsoleStore();
const modeListKey = ref(1);
const modeList = ref([
  { key: 4, title: '互动直播', hide: true, disable: false },
  { key: 5, title: '多语直播', hide: true, disable: false },
  { key: 1, title: '推流直播', hide: false, disable: false },
  { key: 0, title: '网页直播', hide: false, disable: false },
  { key: 2, title: '拉流直播', hide: true, disable: false },
  { key: 6, title: '多平台转推', hide: true },
  { key: 3, title: '文档直播', hide: false, disable: false },
  { key: 7, title: '虚拟直播', hide: false },
  { key: 8, title: '列表直播', hide: false },
]);

const asyncModeList = computed(() => {
  return modeList.value.map((e) => {
    if (judgeMode.consoleInfo.mode === 5 && judgeMode.consoleInfo.studioPid === judgeMode.consoleInfo.id && e.key === 5) {
      e.hide = false;
      modeListKey.value = 5;
    } else if (judgeMode.consoleInfo.mode === 5 && judgeMode.consoleInfo.studioPid === judgeMode.consoleInfo.id && e.key !== 5) {
      e.disable = true;
    } else if (judgeMode.consoleInfo.mode === 5 && judgeMode.consoleInfo.studioPid === judgeMode.consoleInfo.id && e.key === 1) {
      e.hide = true;
    } else if (judgeMode.consoleInfo.mode === 3 && e.key === 4) {
      e.hide = false;
      modeListKey.value = 4;
    } else if (judgeMode.consoleInfo.mode === 3 && (e.key === 0 || e.key === 1)) {
      e.hide = true;
    } else if (judgeMode.consoleInfo.pushType && e.key === 6) {
      e.hide = true;
    } else if (!homeStore.funcData?.virtuallyLive && e.key === 7) {
      e.hide = true;
    } else if (!homeStore.funcData?.ListLive && e.key === 8) {
      e.hide = true;
    } else if (!homeStore.funcData?.WebLiveStreaming && e.key === 0) {
      e.hide = true;
    } else if (!homeStore.funcData?.InteractiveLiveStreaming && e.key === 4) {
      e.hide = true;
    }

    return e;
  });
});
const modeTabs = (event: Event) => {
  const key = parseInt((event.target as HTMLInputElement).dataset.key as string);
  const index = parseInt((event.target as HTMLInputElement).dataset.index as string);
  if (key !== undefined && index !== undefined) {
    if (!asyncModeList.value[index].disable) {
      modeListKey.value = key;
    }
  }
};

const showModeView = computed(() => {
  let webView = WebLive;
  // if (judgeMode.consoleInfo.mode === 5 && judgeMode.consoleInfo.studioPid === judgeMode.consoleInfo.id) {
  // }
  switch (modeListKey.value) {
    case 1:
      webView = PushLive;
      break;
    case 2:
      webView = PullLive;
      break;
    case 3:
      webView = FileLive;
      break;
    case 4:
      webView = InteractLive;
      break;
    case 5:
      webView = Multilingual;
      break;
    case 6:
      webView = PlatformPushs;
      break;
    case 7:
      webView = Virtual;
      break;
    case 8:
      webView = recordBroad;
      break;
    default:
      webView = WebLive;
      break;
  }
  return webView;
});
const route = useRoute();

const consoleStore = useConsoleStore();
const homeStore = useHomeStore();
homeStore.adminId = getUserCache() ? JSON.parse(getUserCache().toString()).id : '';

// 彩排模式删除弹框事件
const dressMode = () => {
  Modal.confirm({
    centered: true,
    icon: createVNode(ExclamationCircleFilled),
    content: `确认${consoleStore.consoleInfo.rehearsalSwitch ? '关闭' : '开启'}彩排模式？`,
    onOk() {
      return new Promise((resolve, reject) => {
        http.liveInformation
          .rehearsalSwitch({
            status: Number(!consoleStore.consoleInfo.rehearsalSwitch),
            studio_id: route.params.studioId,
          })
          .then((res) => {
            if (res.data.data.password) {
              consoleStore.consoleInfo.rehearsalPwd = res.data.data.password;
            }
            consoleStore.consoleInfo.rehearsalSwitch = !consoleStore.consoleInfo.rehearsalSwitch;
            resolve({});
          })
          .catch((err: any) => {
            message.warn(err.data.error);
            resolve(err);
          });
      });
    },
  });
};

const joinStudio = (resData: ConsoleClass) => {
  http.liveChat
    .joinChat({
      type: 'join',
      studio_id: route.params.studioId,
      monitor_id: resData.monitorId,
      client_id: homeStore.clientId,
    })
    .then((joinData) => {
      consoleStore.authority = new Authority(joinData.data.data);
    });
};

// 初始化加入通信
const init = async (data?: any) => {
  if (!data && !homeStore.clientId) {
    return;
  }
  try {
    homeStore.clientId = data ? data.client_id : homeStore.clientId;
    const res: any = await consoleStore.getConsoleInfo(parseInt(route.params.studioId as string));
    const resData = new ConsoleClass(res.data.data);
    document.title = resData.title;
    joinStudio(resData);
    consoleStore.getMemberList(parseInt(route.params.studioId as string));
    if (resData.chatType === 2) {
      if (consoleStore.groupMsg.list.length === 0) {
        consoleStore.getGroupMsg(parseInt(route.params.studioId as string));
        consoleStore.getPrivateMsg(parseInt(route.params.studioId as string));
      }
    } else {
      if (consoleStore.lightGroupMsg.list.length === 0) {
        await consoleStore.getLightGroupMsg(parseInt(route.params.studioId as string));
      }
    }
    toViewLoading.value = false;
  } catch (err: any) {
    console.error(err);
    // message.error(err);
    // router.push({ name: 'Home' });
  }
};
init();
const getGroupMsg = (data: any) => {
  console.log('标准礼物', consoleStore.consoleInfo.gift_display_status);
  const virtualItem = new SocketGMsg(data);

  if (consoleStore.consoleInfo.gift_display_status === 0) {
    if (['txt', 'img', 'redpack'].includes(virtualItem.msg_type)) {
      consoleStore.groupMsg.virtualList.push(new GroupChat(virtualItem));
    }
  } else {
    if (['txt', 'img', 'gift', 'redpack'].includes(virtualItem.msg_type)) {
      consoleStore.groupMsg.virtualList.push(new GroupChat(virtualItem));
    }
  }
};

const getCommentMsg = (data: any) => {
  const virtualItem = new MsgComment(data);
  consoleStore.groupMsg.virtualCommentList.push(virtualItem);
};

const getPrivateMsg = (data: any) => {
  const virtualItem = new SocketPMsg(data);
  if (['txt', 'img'].includes(virtualItem.msg_type)) {
    const form: any = new PrivateChatView(virtualItem);
    if (form.studio_id == parseInt(route.params.studioId as string)) {
      consoleStore.privateMsg.virtualList.push(form);
    }
  }
};

const getLightGroupMsg = (data: any) => {
  console.log('轻聊礼物', consoleStore.consoleInfo.gift_display_status);
  const virtualItem = new LightSocketGMsg(data);

  if (consoleStore.consoleInfo.gift_display_status === 0) {
    // 1 文字 2 礼物 3 图片 4 红包
    if ([1, 3, 4].includes(virtualItem.msg_type)) {
      consoleStore.lightGroupMsg.virtualList.push(virtualItem);
    }
  } else {
    // 1 文字 2 礼物 3 图片 4 红包
    if ([1, 2, 3, 4].includes(virtualItem.msg_type)) {
      consoleStore.lightGroupMsg.virtualList.push(virtualItem);
    }
  }
};

const updateChatNumber = useThrottleFn((data: any) => {
  consoleStore.consoleInfo.uvCount = data.chat_number;
  consoleStore.consoleInfo.pvCount = data.pv_number;
}, 1000);

/**
 *
 * @param deviceType 设备类型
 * @param state 操作状态 加入 or 退出
 */
const upadteMemberCount = (deviceType: number, state: number) => {
  let num = 1;
  if (!state) {
    num = -num;
  }
  switch (deviceType) {
    case 1:
      consoleStore.memberCount.pcCount += num;
      break;
    case 2:
      consoleStore.memberCount.mobileCount += num;
      break;
    case 3:
      consoleStore.memberCount.padCount += num;
      break;
  }
  consoleStore.memberCount.allCount += num;
};
// 在线人数
// const establish = ref(false);
// const listIndex = ref(0);
const memberUpdate = (data: any) => {
  const resData = data;
  if (resData.join === 1) {
    const hasData = consoleStore.memberList.findIndex((e) => e.uid === resData.uid);
    if (hasData === -1) {
      // 没有相同id
      const newArr = new MemberUpdata(resData);
      consoleStore.memberList.unshift(newArr);
    }
    if (hasData !== -1) {
      // 有相同id
      // const formatData = JSON.parse(JSON.stringify(resData).replace(/time/gi, 'visited_at'));
      // formatData.mute = 0;
      const newArr = new subClass(resData);
      consoleStore.memberList[hasData].sub_data.push(newArr);
      consoleStore.memberList = consoleStore.memberList.map((e) => new MemberClass(e));
    }
    upadteMemberCount(resData.device_type, resData.join); // 展示数据,与数组实际数量有区别
    return;
  }
  if (resData.join === 0) {
    const dataId = consoleStore.memberList.findIndex((e) => e.uid === resData.uid);
    if (dataId !== -1) {
      // 有相同id
      if (consoleStore.memberList[dataId].sub_data.length <= 1) {
        consoleStore.memberList.splice(dataId, 1);
      } else {
        const subId = consoleStore.memberList[dataId].sub_data.findIndex((e) => e.device_type === resData.device_type);
        consoleStore.memberList[dataId].sub_data.splice(subId, 1);
        consoleStore.memberList = consoleStore.memberList.map((e) => new MemberClass(e));
      }
    }
    upadteMemberCount(resData.device_type, resData.join);
  }
};
// 原该函数存在相关逻辑，故保留
const initJoin = (data: any) => init(data);

/**
 * 渲染不同消息
 */
const msgInterval = () => {
  msgTimer.value = setInterval(() => {
    if (toViewLoading.value) return; // 加入通讯接口完成后执行
    // 标准版-公共聊天
    const groupMsg = consoleStore.groupMsg;
    if (groupMsg.virtualList.length > 0) {
      const item: any = groupMsg.virtualList.splice(0, consoleStore.msgRenderCount);
      const data = item.reverse();
      groupMsg.list.splice(groupMsg.topCount, 0, ...data);
    }
    // 轻聊版-公共聊天
    const lightGroupMsg = consoleStore.lightGroupMsg;
    if (lightGroupMsg.virtualList.length > 0) {
      const item: LightGMsg[] = lightGroupMsg.virtualList.splice(0, consoleStore.msgRenderCount);
      const data = item.reverse();
      if (consoleStore.groupListScrollStatus) {
        lightGroupMsg.provisionalList = data.concat(lightGroupMsg.provisionalList);
        return true;
      }
      lightGroupMsg.list = data.concat(lightGroupMsg.list);
    }
    // 公共聊天-评论（标准版 and 轻聊版）
    if (consoleStore.groupMsg.virtualCommentList.length > 0) {
      const item: any = consoleStore.groupMsg.virtualCommentList.shift();
      const index = consoleStore.groupMsg.list.findIndex((e) => e.msg_id === item.group_msg_id);
      consoleStore.groupMsg.list[index].comment.unshift(item);
    }
    // 标准版-私聊
    if (consoleStore.privateMsg.virtualList.length > 0) {
      const item: any = consoleStore.privateMsg.virtualList.shift();
      if (consoleStore.currentDialog.pmsgItem.id && item.chat_list_id === consoleStore.currentDialog.pmsgItem.id) {
        consoleStore.currentDialog.list.unshift(item);
        consoleStore.privateMsg.newMsgCount += consoleStore.chatType === 1 ? 1 : 0;
      } else if (item.to_uid === consoleStore.authority.id || item.uid === consoleStore.authority.id) {
        if (consoleStore.currentDialog.user?.to_uid === item.to_uid) {
          consoleStore.currentDialog.list.unshift(item);
          return;
        }
        const index = consoleStore.privateMsg.list.findIndex((e) => e.id === item.chat_list_id);
        if (index === -1 && consoleStore.currentDialog.user?.to_uid === item.to_uid) {
          consoleStore.getPrivateMsg(parseInt(route.params.studioId as string), item.chat_list_id);
          consoleStore.currentDialog.list.unshift(item);
        } else if ((index !== -1 && consoleStore.privateMsg.list[index].news === 0) || index === -1) {
          consoleStore.privateMsg.newMsgCount += 1;
        }
      } else {
        // 添加观众的私聊消息
        const groupMsg = consoleStore.groupMsg;
        const res = consoleStore.groupMsg.list.findIndex((e) => item.chat_list_id === e.chat_list_id);
        if (res === -1) {
          groupMsg.list.splice(groupMsg.topCount, 0, {
            alias: '',
            avatar: item.avatar,
            avatar_url: item.avatar_url,
            comment: [],
            content: '',
            content_url: '',
            group: item.group,
            level: item.level,
            like: 0,
            like_num: 0,
            msg_id: item.chat_list_id,
            msg_type: item.msg_type,
            nickname: item.nickname,
            status: 0,
            time: item.time,
            type: item.type,
            uid: item.uid,
            created_at: `${new Date().getFullYear()}-${item.time}`,
            chat_list_id: item.chat_list_id,
            chat_record: [
              {
                content: item.content,
                created_at: `${new Date().getFullYear()}-${item.time}`,
                msg_id: item.msg_id,
                msg_type: item.msg_type,
                updated_at: `${new Date().getFullYear()}-${item.time}`,
                send_status: item.type, //审核别人私信消息状态
                to_uid: item.to_uid,
                avatar: item.avatar,
                avatar_url: item.avatar_url,
                uid: item.uid,
                nickname: item.nickname,
                chat_list_id: item.chat_list_id,
              },
            ],
            to_avatar: item.to_avatar,
            to_avatar_url: item.to_avatar_url,
            to_nickname: item.to_nickname,
            to_uid: item.to_uid,
          } as any);
        }
      }
    }
  }, 500);
};

const socketStore = useSocketStore();
EventBus.on('init', initJoin);
EventBus.on('groupMsg', getGroupMsg);
EventBus.on('commentMsg', getCommentMsg);
EventBus.on('privateMsg', getPrivateMsg);
EventBus.on('sendLightGroup', getLightGroupMsg);
EventBus.on('updateChatNumber', updateChatNumber);
EventBus.on('memberUpdate', memberUpdate);
EventBus.on('setTopConsoleMsg', socketSetMsgTop);
EventBus.on('setHideConsoleMsg', socketSetMsgShow);
EventBus.on('delConsoleMsg', socketDelMsg);
EventBus.on('clearMsg', socketClearMsg);
onMounted(() => {
  msgInterval();
});
onUnmounted(async () => {
  EventBus.off('init', initJoin);
  EventBus.off('groupMsg', getGroupMsg);
  EventBus.off('commentMsg', getCommentMsg);
  EventBus.off('privateMsg', getPrivateMsg);
  EventBus.off('sendLightGroup', getLightGroupMsg);
  EventBus.off('updateChatNumber', updateChatNumber);
  EventBus.off('memberUpdate', memberUpdate);
  EventBus.off('setTopConsoleMsg', socketSetMsgTop);
  EventBus.off('setHideConsoleMsg', socketSetMsgShow);
  EventBus.off('delConsoleMsg', socketDelMsg);
  EventBus.off('clearMsg', socketClearMsg);
  clearInterval(msgTimer.value);
  consoleStore.$reset();
  clearPending();
  if (socketStore.socket) {
    const wss: WebSocket = await socketStore.socket.getInstance();
    wss.close();
  }
});

const copyText = (btns: string) => {
  const ClipboardJSObj = new ClipboardJS(btns);
  ClipboardJSObj.on('success', (e) => {
    message.destroy();
    message.info('复制成功');
    e.clearSelection();
  });
  ClipboardJSObj.on('error', () => {
    message.destroy();
    message.info('复制失败');
  });
};
// 骨架屏 聊天内容，icon
const skeleton = reactive<any>([]);
for (let i = 0; i < 3; i++) {
  skeleton.push({ key: i });
}
const imgArr = ref<any>([]);
for (let i = 0; i < 9; i++) {
  imgArr.value.push({ key: i });
}

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_unref(consoleStore).consoleInfo.mode === 5)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_unref(consoleStore).consoleInfo.languageImageUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(consoleStore).consoleInfo.languageImageUrl
                      }, null, 8, _hoisted_7))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(consoleStore).consoleInfo.title), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_unref(helperStatus) !== 1 || _unref(store).state.user.helperInfo.set === 1)
              ? (_openBlock(), _createBlock(_unref(aPopover), { key: 0 }, {
                  content: _withCtx(() => [
                    _hoisted_10
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createTextVNode(" 彩排模式  "),
                        _createElementVNode("span", null, _toDisplayString(_unref(consoleStore).consoleInfo.rehearsalSwitch ? `(密码${_unref(consoleStore).consoleInfo.rehearsalPwd})` : ''), 1)
                      ]),
                      _createVNode(_unref(aSwitch), {
                        checked: _unref(consoleStore).consoleInfo.rehearsalSwitch,
                        class: "btns_txt",
                        onChange: dressMode
                      }, null, 8, ["checked"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(consoleStore).consoleInfo.rehearsalSwitch)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "copy password",
                  "data-clipboard-text": 
                '活动名称：' +
                _unref(consoleStore).consoleInfo.title +
                '\n' +
                '观看链接：' +
                _unref(consoleStore).consoleInfo.qrCodeUrl +
                '\n' +
                '监看密码：' +
                _unref(consoleStore).consoleInfo.rehearsalPwd
              ,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (copyText('.password')))
                }, [
                  _createVNode(_component_svg_icon, {
                    "icon-class": "control_copy",
                    style: {"cursor":"pointer"}
                  })
                ], 8, _hoisted_13))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          (!toViewLoading.value)
            ? (_openBlock(), _createBlock(_unref(LiveView), { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_15))
        ])
      ]),
      (_unref(helperStatus) && _unref(store).state.user.helperInfo.control === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modeList.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.key,
                    class: "skeleton_tabs_pan"
                  }, _toDisplayString(item.title), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skeleton, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "skeleton_box",
                    key: item.key
                  }, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skeleton, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "ske_con_cen_item",
                          key: item.key
                        }))
                      }), 128)),
                      _hoisted_22
                    ]),
                    _hoisted_23
                  ]))
                }), 128)),
                _hoisted_24
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(asyncModeList), (item, index) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: item.key,
                  class: _normalizeClass([{ actived: modeListKey.value === item.key, disabled: item.disable }, "mode_tabpane media"]),
                  "data-key": item.key,
                  "data-index": index,
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (modeTabs($event)), ["stop"]))
                }, [
                  _createTextVNode(_toDisplayString(item.title) + " ", 1),
                  (item.key === 7)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_29, _hoisted_32))
                      ]))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_27)), [
                  [_vShow, !item.hide]
                ])
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_33, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(showModeView))))
            ])
          ]))
    ]),
    ((_unref(helperStatus) && _unref(store).state.user.helperInfo.chat === 0) || toViewLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(chatList, (item) => {
                return _createElementVNode("div", {
                  key: item.key,
                  class: "nochat_tabs_pan"
                }, _toDisplayString(item.title), 1)
              }), 64))
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skeleton, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "right_bg",
                      key: item.key
                    }))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(chatList, (item) => {
                  return _createElementVNode("div", {
                    key: item.key
                  }, [
                    _createVNode(_unref(aSkeleton), { avatar: "" })
                  ])
                }), 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imgArr.value, (item) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: item.key
                    }))
                  }), 128))
                ]),
                _hoisted_45
              ]),
              _hoisted_46
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_47, [
          _createElementVNode("div", {
            class: "mod_c_title chat_tabs",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (onSwitchTab($event)))
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(chatList, (item) => {
              return _createElementVNode("div", {
                key: item.key,
                class: _normalizeClass([{ actived: tabKey.value === item.key }, "chat_tabpane"]),
                "data-key": item.key
              }, _toDisplayString(item.title), 11, _hoisted_48)
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_49, [
            (showView(0))
              ? (_openBlock(), _createBlock(LiveChat, { key: 0 }))
              : _createCommentVNode("", true),
            (showView(1))
              ? (_openBlock(), _createBlock(MemberList, {
                  key: 1,
                  "onClick:toChat": _cache[3] || (_cache[3] = () => (tabKey.value = 0))
                }))
              : _createCommentVNode("", true),
            (showView(2))
              ? (_openBlock(), _createBlock(ForbiddenWord, { key: 2 }))
              : _createCommentVNode("", true),
            (showView(3))
              ? (_openBlock(), _createBlock(BlackList, { key: 3 }))
              : _createCommentVNode("", true)
          ])
        ]))
  ]))
}
}

})